<template>
  <v-container tag="section">
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row justify="center">
        <v-col cols="12">
          <parametros ref="parametrosREF" :item="item" :title="title" />
        </v-col>
        <v-col cols="12">
          <v-btn
            id="btn-save-aging"
            color="green"
            min-width="100"
            style="float: right"
            :disabled="invalid"
            :loading="loading"
            @click="salvar()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
  import AgingService from '@/services/AgingService';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    components: {
      Parametros: () => import('@/components/aging/Parametros.vue')
    },
    mixins: [tourMixins],

    data: () => ({
      item: {
        titulo: '',
        data_base: '',
        data_projetada: '',
        tipo_base: 'AIS',
        tucs: []
      },
      loading: false,
      arrTour: [
        {
          element: '#titulo-aging',
          intro: 'Aqui você poderá inserir um título para a sua análise.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#tipo-base-aging',
          intro: 'Selecione se o processamento utilizará a base AIS ou LAUDO.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#date-picker-data-base-aging',
          intro: 'Informe a data base utilizada na análise de depreciação.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#date-picker-data-projetada-aging',
          intro: 'Informe até qual mês a projeção de depreciação deve ser calculada.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#tucs-aging',
          intro: 'Selecione as TUCs que serão consideradas no processamento.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#btn-save-aging',
          intro: 'Após preencher os parâmetros, clique aqui para salvar e executar a análise.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ]
    }),

    computed: {
      title() {
        return this.$route.params.id ? 'Editar Aging' : 'Adicionar Aging';
      }
    },

    mounted() {
      if (this.$route.params.id) {
        this.getById(this.$route.params.id);
      }
      this.iniciarTourPagina();
    },

    methods: {
      getById(id) {
        AgingService.getById(id)
          .then(({ data }) => {
            this.item = {
              titulo: data.data.titulo,
              data_base: data.data.data_base,
              data_projetada: data.data.data_projetada,
              tipo_base: data.data.tipo_base,
              tucs: data.data.tucs || []
            };
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar Aging.', '', { position: 'topRight' });
          });
      },

      salvar() {
        const payload = this.$refs.parametrosREF.exportData();
        const id = this.$route.params.id;

        this.loading = true;

        AgingService.salvar(payload, id)
          .then(() => {
            this.$toast.success('Aging salvo com sucesso.', '', { position: 'topRight' });
            this.$router.push({ name: 'Aging Historico' });
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao salvar Aging.', '', { position: 'topRight' });
          })
          .finally(() => {
            this.loading = false;
          });
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        this.iniciarTour(this.arrTour);
      }
    }
  };
</script>
